'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import '../list/index.js';
import { ListItem } from '../list/list-item.js';

/**
 * ErrorSummaryItem component, used to display an error link in the ErrorSummary.
 *
 * @example
 * <ErrorSummaryItem>
 *  <ErrorSummaryLink href="#">
 *    Link to error
 *  </ErrorSummaryLink>
 * </ErrorSummaryItem>
 */
const ErrorSummaryItem = forwardRef(function ErrorSummaryItem({ ...rest }, ref) {
    return jsx(ListItem, { ref: ref, ...rest });
});

export { ErrorSummaryItem };
